import { connectedStore } from '../../store';
import getSupportedLocalesSelector from '../selectors/supported-locales';

const getSupportedLocales = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return getSupportedLocalesSelector(state);
};

export default getSupportedLocales;
